<template>
  <Modal v-model="visible" :footer-hide="true" :transfer="true" :mask-closable="false" class="my-modal" :class="className" width="360px">
    <p class="title">验证提醒</p>
    <p class="sub-title">涉及敏感信息，请输入您的用户姓名、手机号后四位后查询</p>
    <div class="code-wrap">
      <input ref="inputRef" :disabled="false" class="input-code" v-model="formData.name" type="text" />
      <span class="name">{{ name }}</span>
    </div>
    <div class="code-wrap">
      <input class="input-code1" :maxlength="4" v-model="formData.mobile" type="text" />
    </div>
    <div class="ivu-modal-footer">
      <span type="text" class="cancel" @click="cancel">取消</span>
      <span type="primary" class="ok" @click="ok">确定</span>
    </div>
  </Modal>
</template>
  
  <script>
export default {
  props: {
    className: {
      type: String,
      default: ''
    },
    transfer: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      name: '',
      params: [],
      userInfo: {},
      formData: {
        name: '',
        mobile: ''
      }
    };
  },
  watch: {},
  methods: {
    open(...params) {
      console.log(params);
      this.params = params;
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
      this.name = this.userInfo.fuzzUserName.replace('*', '');
      // this.row = row;
      // this.code = code;
      this.formData = { name: '', mobile: '' };
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.inputRef.focus();
      });
    },
    cancel() {
      this.visible = false;
    },
    ok() {
      if (!this.formData.name.trim()) {
        return this.$notice.error('请输入您的用户姓名后查询');
      }
      if (!this.formData.mobile.trim()) {
        return this.$notice.error('请输入手机号后四位后查询');
      }
      this.$http({
        url: '/buz/permissionLog/verify',
        type: 'POST',
        data: this.formData
      })
        .then(res => {
          if (res.data) {
            let code = '';
            if (this.params.length > 1) {
              code = this.params[1];
            }
            this.params[0]['validName' + code] = true;
            this.visible = false;
            setTimeout(() => {
              // fix 修复查看pdf导致页面不能滑动的bug
              this.$emit('success', ...this.params);
            }, 500)
          }
        })
        .catch(() => { });
    }
  }
};
</script>
  <style lang="scss" scoped>
.my-modal {
  /deep/.ivu-icon-ios-close {
    color: #8a9095 !important;
    font-size: 36px !important;
    font-weight: 600;
  }

  /deep/ .ivu-modal-content {
    overflow: hidden;
    border-radius: 10px;
  }

  /deep/ {
    .ivu-modal-body {
      font-size: 13px;
      background-color: #fff !important;
    }

    .code-wrap {
      position: relative;
      margin: 0 0 10px;
      width: 300px;
      height: 48px;
      line-height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px 4px 4px 4px;

      .name {
        color: #3c464f;
        font-size: 28px;
        margin-left: 6px;
        font-weight: 400;
      }
      .ivu-input-wrapper {
        width: unset;
      }
      .input-code {
        background: #f7f8fa;
        width: 40px;
        margin-left: 15px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        padding: 0;
        color: #3c464f;
        font-size: 28px;
        margin-left: 10px;
        font-weight: 400;
      }
      .input-code1 {
        background: #f7f8fa;
        width: 160px;
        margin-left: 15px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        padding: 0;
        color: #3c464f;
        font-size: 28px;
        margin-left: 10px;
        font-weight: 400;
      }
    }

    .ivu-modal-footer {
      .ok {
        background: #236dff;
        color: #fff;
        border: 1px solid #236dff;
      }
      .cancel {
        border: 1px solid #236dff;
        color: #236dff;
      }
      .ok,
      .cancel {
        width: 120px;
        height: 36px;
        border-radius: 4px;
        font-size: 14px;
        line-height: 36px;
        border-radius: 2px;
        font-size: 13px;
        display: inline-block;
        cursor: pointer;
      }

      .ok {
        margin-left: 20px;
        color: #ffffff;
        border: transparent;
      }
    }
  }

  .title {
    padding: 30px 0 15px;
    font-size: 20px;
    font-weight: 600;
    color: #3c464f;
    line-height: 28px;
    text-align: center;
  }
  .sub-title {
    padding: 0 0 10px 0;
  }
}
</style>
  